import React from "react";
import Button from "react-bootstrap/esm/Button";

type callback = () => void;

interface DangerButtonProps {
  buttonText: string;
  disabled?: boolean;
  onClick: callback;
}

export default class DangerButton extends React.Component<DangerButtonProps> {
  render() {
    const disabledPointer = {
      cursor: 'not-allowed'
    }

    const normalPointer = {
      cursor: 'pointer'
    }

    return (
      <Button variant="danger" 
              className="mr-1" 
              onClick={this.props.onClick} 
              disabled={this.props.disabled} style={this.props.disabled ? disabledPointer : normalPointer}
      >
        {this.props.buttonText}
      </Button>
    );
  }
}

